import styled from 'styled-components';

export const FieldRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const FieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FieldLabel = styled.span`
  font-size: 12px;
  color: #52525b;
  line-height: 1.4;
`;

export const FieldValue = styled.span`
  font-size: 12px;
  color: #18181b;
  font-variant-numeric: tabular-nums;
`;

export const ColorButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  background: #ffffff;
  font-size: 12px;
  color: #3f3f46;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: #a1a1aa;
  }
`;

interface ColorPreviewProps {
  $color: string;
  $empty?: boolean;
}

export const ColorPreview = styled.span<ColorPreviewProps>`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: ${({ $color, $empty }) => ($empty
    ? 'repeating-linear-gradient(45deg, #f4f4f5 0 4px, #ffffff 4px 8px)'
    : $color)};
`;

export const PaletteLabel = styled.span`
  display: block;
  margin-bottom: 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #a1a1aa;
`;

export const SwatchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
`;

interface SwatchButtonProps {
  $color: string;
  $active: boolean;
}

export const SwatchButton = styled.button<SwatchButtonProps>`
  width: 22px;
  height: 22px;
  border-radius: 5px;
  background: ${({ $color }) => $color};
  border: 2px solid ${({ $active }) => ($active ? '#0b4f9e' : 'rgba(0, 0, 0, 0.08)')};
  transition: transform 0.12s ease;

  &:hover {
    transform: scale(1.08);
  }
`;

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f1f1;
`;

export const SectionTitle = styled.h4`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #71717a;
`;

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
